import PropTypes from "prop-types";
import { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";

import "./PageAnonymous.css";

class PageAnonymous extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
  };

  render() {
    return (
      <Container fluid>
        <Row>
          <Col>
            <div className="pageanonymous-header">
              <h1>{this.props.title}</h1>
            </div>
            <div className="pageanonymous-body">{this.props.children}</div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default PageAnonymous;
